import { RequestModel } from "./RequestModel";
import { TechnicianModel } from "./TechnicianModel";
import { ContactModel } from "./ClientModel";

import Helper, { DateFormat } from "@/services/Helper";

class MileageModel
{
    constructor(obj?: MileageModel)
    {
        if (obj)
        {
            Object.assign(this, obj);

            // Access DB is storing these Dates as local.
            if (obj.DateAndTime)
            {
                let tmp = new Date((obj.DateAndTime + "").split("T")[0] + " 00:00:00");
                this.DateAndTime = tmp.toUTCString();
            }

            if (obj.ReimbursementDate)
            {
                let tmp = new Date((obj.ReimbursementDate + "").split("T")[0] + " 00:00:00");
                this.ReimbursementDate = tmp.toUTCString();
            }

            if (obj.Contact)
            {
                this.Contact = new ContactModel(obj.Contact);
                this.CustomerNumber = this.Contact.CustomerNumber;
            }

            if (obj.Technician)
            {
                this.Technician = new TechnicianModel(obj.Technician);
            }

            if (obj.Request)
            {
                this.Request = new RequestModel(obj.Request);
                this.RequestId = this.Request.Id;
            }
        }
        else
        {
            // Set defaults for new records
            this._DateAndTime = Helper.dateToInput(new Date(), DateFormat.Date);
            this.Status = 1;
        }
    }

    public Technician?: TechnicianModel | null;

    public Request?: RequestModel | null;

    public Contact?: ContactModel | null;

    public Id?: number | null;
    
    public TechnicianId?: number | null;

    public RequestId?: number | null;

    public CustomerNumber?: number | null;
    
    private _DateAndTime?: string | null;

    public get DateAndTime (): string | null
    {
        return Helper.dateToInput(this.DateAndTimeAsDate, DateFormat.Date) || null;
    }

    public set DateAndTime (val: string | null)
    {
        this._DateAndTime = val || null;
    }

    public get DateAndTimeAsDate (): Date | null
    {
        if (this._DateAndTime)
        {
            return Helper.dateFromString(this._DateAndTime) || null;
        }

        return null;
    }
    
    public Miles?: number | null;
    
    public Notes?: string | null;
    
    private _ReimbursementDate?: string | null;

    public get ReimbursementDate (): string | null
    {
        return Helper.dateToInput(this.ReimbursementDateAsDate, DateFormat.Date) || null;
    }

    public set ReimbursementDate (val: string | null)
    {
        this._ReimbursementDate = val || null;
    }

    public get ReimbursementDateAsDate (): Date | null
    {
        if (this._ReimbursementDate)
        {
            return Helper.dateFromString(this._ReimbursementDate) || null;
        }

        return null;
    }
    
    public Vehicle?: string | null;
    
    public OdometerStart?: number | null;
    
    public OdometerEnd?: number | null;
    
    public Status?: number | null;

    public RecCount?: number | null;
}

class MileageModelFilter 
{
    public Id?: Array<number> = [];

    public RequestId?: Array<number> = [];
    
    public ContactId?: Array<number> = [];
    
    public TechId?: Array<number> = [];
    
    public IncludeRequest?: boolean = false;
    
    public IncludeContact?: boolean = false;
    
    public StartDate?: Date = new Date();
    
    public EndDate?: Date = new Date();
    
    public Page?: number = 0;
    
    public Size?: number = 25; 
}

export { MileageModel, MileageModelFilter }